module.exports = __webpack_public_path__ + "img/back-to-list-dark.47a865fb.svg";